import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './navs.css';
import logo from './../../photos/logo.png';

function Navs(){
    return(
        <Navbar fixed='top' expand="lg">
        <Container>
          <Navbar.Brand href="#home">
            <img src={logo} alt=''></img>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#section1">Home</Nav.Link>
              <Nav.Link href="#section-tow">About Us</Nav.Link>
              <Nav.Link href="#section2">Explore Foods</Nav.Link>
              <Nav.Link href="#section3">Reviews</Nav.Link>
              <Nav.Link href="#slider-section">FAQ</Nav.Link>
            </Nav>
            <Nav>
            <Nav.Link id='call'>+201143573704</Nav.Link>
          </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    )
}
export default Navs;